import { IBlowDef, Segment } from './types';
import { seg } from './segments';
import { ParamReader } from './ParamReader';

/**
 * Shared body for flat/percent stat mods. Param form: `Mod[;SkillID1,SkillID2,...]`
 * (a few blows scope the mod to specific skills via a trailing id list).
 */
function statMod(statName: string, percent: boolean, mod: number): IBlowDef {
    return {
        name: percent ? `${statName} %` : statName,
        describe({ params }): Segment[] | null {
            const fields = params.fields();
            let amount = ParamReader.num(fields[0]);
            if (isNaN(amount)) {
                return null;
            }
            amount += mod;
            const dir = amount < 0 ? 'decreased' : 'increased';
            const abs = Math.abs(amount);
            const skillIds = ParamReader.numList(fields.slice(1).join(','), ',')
                .filter((v) => v > 1);
            const out: Segment[] = [];
            if (skillIds.length) {
                out.push(`${statName} `, 'during ',
                    seg.list(skillIds.map((id) => [seg.skill(id)] as Segment[])), ' ',
                    `${dir} by `, percent ? seg.pct(abs) : seg.num(abs));
            } else {
                out.push(`${statName} ${dir} by `, percent ? seg.pct(abs) : seg.num(abs));
            }
            return out;
        },
    };
}

export function statIncrease(statName: string): IBlowDef {
    return statMod(statName, false, 0);
}

/** `mod` is added to the parsed amount before display (e.g. -1 for "ratio" style blows 134/135). */
export function statIncreasePercent(statName: string, mod: number = 0): IBlowDef {
    return statMod(statName, true, mod);
}
